'use client';

import { useState, useEffect } from 'react';

interface RevenueData {
  label: string;
  value: number;
}

interface RevenueChartProps {
  data: RevenueData[];
}

export default function RevenueChart({ data }: RevenueChartProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="glass-card rounded-2xl p-6 h-96 animate-pulse">
        <div className="h-8 bg-accent rounded w-1/3 mb-4"></div>
        <div className="h-full bg-accent rounded"></div>
      </div>
    );
  }

  const maxValue = Math.max(...data.map((d) => d.value));

  return (
    <div className="glass-card rounded-2xl p-6">
      <h3 className="text-xl font-black text-foreground font-heading mb-6">
        Revenue Trends (Last 7 Days)
      </h3>

      <div className="flex items-end justify-between gap-4 h-64">
        {data.map((item, index) => {
          const height = (item.value / maxValue) * 100;
          return (
            <div key={index} className="flex-1 flex flex-col items-center gap-2">
              <div className="w-full flex flex-col items-center justify-end h-full">
                <div className="text-xs font-bold text-foreground mb-1">
                  ${item.value.toFixed(0)}
                </div>
                <div
                  className="w-full bg-gradient-to-t from-primary to-primary/50 rounded-t-lg transition-all duration-500 hover:from-primary/80 hover:to-primary/30"
                  style={{ height: `${height}%` }}
                ></div>
              </div>
              <div className="text-xs font-semibold text-muted-foreground uppercase">
                {item.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}